<template>
  <div class="d-badge">
    <slot />
    <div v-show="isActive" class="d-badge--wrapper">
      <span class="d-badge--badge text-white" :class="[contentClasses]">{{ content }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      content: {
        type: [String, Number],
        default: null,
      },

      value: {
        type: [Number, Boolean],
        default: true,
      },

      color: {
        type: String,
        default: 'primary-500',
      },

      offsetX: [Number, String],
      offsetY: [Number, String],
    },

    computed: {
      contentClasses() {
        return {
          [`bg-${this.color}`]: true,
        };
      },

      isActive() {
        return this.value;
      },
    },
  };
</script>

<style scoped>
.d-badge {
  position: relative;
}

.d-badge--wrapper {
    flex: 0 1;
    height: 100%;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
}

.d-badge--badge {
  bottom: calc(100% - 17px); /* Original calc(100% - 4px) */
  left: calc(100% - 7px); /* Original calc(100% - 4px) */
  right: auto;
  top: auto;

  border-radius: 10px;
  font-size: 11px;
  height: 17px;
  letter-spacing: 0;
  min-width: 17px;
  padding: 1px 4px;
  pointer-events: auto;
  position: absolute;
  text-align: center;
  text-indent: 0;
  top: auto;
  transition: .3s cubic-bezier(.25,.8,.5,1);
  white-space: nowrap;
}
</style>